import { SET_STAFF_COUNT, SET_STAFF_DATA } from "../../actions/types/types";

const initState = {
  staffs: [],
  staffCount: 0,
  checkPasswordModalOpen: false,
};

const StaffReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_STAFF_DATA:
      return {
        ...state,
        staffs: action.payload.data,
      };
    case SET_STAFF_COUNT:
      return {
        ...state,
        staffCount: action.payload.data,
      };
    case "SET_CHECK_PASSWORD_MODAL_OPEN":
      return {
        ...state,
        checkPasswordModalOpen: action.payload.data,
      };
    default:
      return { ...state };
  }
};

export default StaffReducer;
